import type { Location } from "react-router-dom";
import { AppRoutes } from "../../../common/routes/app_routes";

/**
 * Where to send the user after a successful login: back to the page that
 * bounced them to /login (`RequireAuth`'s `state.from`) if there is one,
 * otherwise `fallback` (defaults to the homepage).
 */
export function resolvePostLoginRedirect(location: Location, fallback: string = AppRoutes.INDEX): string {
  const from = (location.state as { from?: Location } | null)?.from;
  if (!from) return fallback;
  return `${from.pathname}${from.search}${from.hash}`;
}

/** Landing route for a freshly logged-in user with no `from` to return to. */
export function dashboardRouteForRole(role?: string): string {
  return role === "admin" ? AppRoutes.ADMIN_DASHBOARD : AppRoutes.DASHBOARD;
}
